/* eslint-disable react-hooks/exhaustive-deps */
import DataGridColumn from "./DataGridColumn";
import { FlexGridCellTemplate } from "@grapecity/wijmo.react.grid";
import { useEffect, useState } from "react";
import getNewDateObj from "../../../lib/common/getNewDateObj";

function DataGridTimeColumn(props) {
    const { schema, ...others } = props;

    const [cellTemplate, setCellTemplate] = useState((ctx) => {
        return <></>;
    });

    const secToHHMMSS = (numSecs) => {
        let secNum = parseInt(numSecs, 10);
        let hours = Math.floor(secNum / 3600).toString().padStart(2, '0');
        let minutes = Math.floor((secNum - (hours * 3600)) / 60).toString().padStart(2, '0');;
        let seconds = (secNum - (hours * 3600) - (minutes * 60)).toString().padStart(2, '0');;
        return `${hours}:${minutes}:${seconds}`;
    }

    const minToHHMMSS = (numSecs) => {
        let secNum = parseInt(numSecs, 10);
        let hours = Math.floor(secNum / 60).toString().padStart(2, '0');
        let minutes = Math.floor((secNum - (hours * 60))).toString().padStart(2, '0');;
        let seconds = "00"
        return `${hours}:${minutes}:${seconds}`;
    }

    useEffect(() => {
        if (schema) {
            if (schema?.grid?.type === "time") {
                setCellTemplate(() => (ctx) => {
                    if (ctx.item[schema.name]) {
                        let value = ctx.item[schema.name]?.toString().replaceAll(/,/g, "")
                        if (schema?.grid?.secToTime) {
                            return <span>{secToHHMMSS(value)}</span>
                        }

                        if (schema?.grid?.minToTime) {
                            return <span>{minToHHMMSS(value)}</span>
                        }

                        let date = getNewDateObj(value);

                        const val =
                            ("0" + date.getHours()).slice(-2) +
                            ":" +
                            ("0" + date.getMinutes()).slice(-2) +
                            ":" +
                            ("0" + date.getSeconds()).slice(-2);

                        return <span>{val}</span>;
                    } else {
                        return <span></span>;
                    }
                });
            }
        }
    }, [schema]);

    return (
        <DataGridColumn schema={schema} {...others}>
            <FlexGridCellTemplate cellType="Cell" template={cellTemplate} />
        </DataGridColumn>
    );
}

export default DataGridTimeColumn;
